module.exports = __webpack_public_path__ + "img/icon-pdf.fca765e.png";